<template>
  <div class="testimonials" v-if="testimonials.length > 0">
    <h2 class="testimonials__heading">Reference</h2>
    <TestimonialLink v-for="(item, index) in testimonials" :key="index" :item="item"></TestimonialLink>
  </div>
</template>

<script>
import TestimonialLink from "@/components/TestimonialLink";

export default {
  data() {
    return {
      testimonials: [],
      testimonialsSample: [
        {
          text:
            '"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam et lorem quam. Nunc aliquam neque vel elit fringilla, ut sollicitudin velit porttitor. Etiam lobortis odio eu condimentum feugiat. Integer hendrerit erat. Nunc aliquam neque vel elit fringilla, ut sollicitudin velit porttitor. Etiam lobortis odio eu condimentum."',
          name: "Karel Voprátka",
          post: "Vedoucí oddělení památkové péče",
          src: "/img/foto_breta.jpg",
          alt: "Karel Voprátka",
        },
        {
          text:
            '"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam et lorem quam. Nunc aliquam neque vel elit fringilla, ut sollicitudin velit porttitor. Etiam lobortis odio eu condimentum feugiat. Integer hendrerit erat. Nunc aliquam neque vel elit fringilla, ut sollicitudin velit porttitor. Etiam lobortis odio eu condimentum."',
          name: "Karel Voprátka",
          post: "Vedoucí oddělení památkové péče",
          src: "/img/foto_breta.jpg",
          alt: "Karel Voprátka",
        },
        {
          text:
            '"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam et lorem quam. Nunc aliquam neque vel elit fringilla, ut sollicitudin velit porttitor. Etiam lobortis odio eu condimentum feugiat. Integer hendrerit erat. Nunc aliquam neque vel elit fringilla, ut sollicitudin velit porttitor. Etiam lobortis odio eu condimentum."',
          name: "Karel Voprátka",
          post: "Vedoucí oddělení památkové péče",
          src: "/img/foto_breta.jpg",
          alt: "Karel Voprátka",
        },
      ],
    };
  },
  components: {
    TestimonialLink,
  },
};
</script>
<style>
.testimonials {
  grid-column: span 2;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 48px;
}

h2.testimonials__heading {
  grid-column: span 3;
  text-align: center;
  margin-bottom: 0 !important;
}
</style>